import { getAPI } from "./Networking";
import {
  OpsAnalyticsData,
  OrdersList,
} from "../models/Dashboard/OpsDashboard/OpsAnalytics";
import {
  AnalyticsGraphResponse,
  LabelValue,
} from "../models/Dashboard/Analytics";
import dayjs from "dayjs";
import { VendorsAnalyticsAPIFilters } from "../models/Dashboard/VendorDashboard/VendorsAnalyticsFilters";
import { ProposalAnalyticsAPIFilters } from "../models/Dashboard/ProposalDashboard/ProposalAnalyticsFilters";

export default class VendorsAnalyticsDashboardAPI {
  getReportData = async (
    url: string,
    filters: VendorsAnalyticsAPIFilters,
  ): Promise<any[]> => {
    try {
      const start_date = dayjs(filters.start_date, "YYYY-MM-DD")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const queryParams = new URLSearchParams();

      if (start_date) queryParams.append("start_date", start_date);

      if (end_date) queryParams.append("end_date", end_date);

      if (filters.vendor_id && filters.vendor_id.length > 0) {
        queryParams.append(
          "vendor_id",
          filters.vendor_id.map((item) => item.id).join(","),
        );
      }
      if (filters.product_id && filters.product_id.length > 0) {
        queryParams.append(
          "product_id",
          filters.product_id.map((item) => item.id).join(","),
        );
      }

      const response = await getAPI(`${url}?${queryParams.toString()}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getTatsData = async (
    url: string,
    filters: VendorsAnalyticsAPIFilters,
  ): Promise<LabelValue[] | AnalyticsGraphResponse[] | OpsAnalyticsData> => {
    try {
      const start_date = dayjs(filters.start_date, "YYYY-MM-DD")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const queryParams = new URLSearchParams();

      if (start_date) queryParams.append("start_date", start_date);

      if (end_date) queryParams.append("end_date", end_date);

      if (filters.vendor_id && filters.vendor_id.length > 0) {
        queryParams.append(
          "vendor_id",
          filters.vendor_id.map((item) => item.id).join(","),
        );
      }
      if (filters.admin_id && filters.admin_id.length > 0) {
        queryParams.append(
          "admin_id",
          filters.admin_id.map((item) => item.id).join(","),
        );
      }

      if (filters.product_id && filters.product_id.length > 0) {
        queryParams.append(
          "product_id",
          filters.product_id.map((item) => item.id).join(","),
        );
      }

      const response = await getAPI(
        `/v5/ops-analytics/vendors${url}?${queryParams.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getProposalTatsData = async (
    url: string,
    filters: ProposalAnalyticsAPIFilters,
  ): Promise<LabelValue[] | AnalyticsGraphResponse[] | OpsAnalyticsData> => {
    try {
      const start_date = dayjs(filters.start_date, "YYYY-MM-DD")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const queryParams = new URLSearchParams();

      if (start_date) queryParams.append("start_date", start_date);

      if (end_date) queryParams.append("end_date", end_date);

      if (filters.order_id && filters.order_id.length > 0) {
        queryParams.append(
          "order_id",
          filters.order_id.map((item) => item.id).join(","),
        );
      }
      const response = await getAPI(
        `/v5/ops-analytics/vendors${url}?${queryParams.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
